// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tile---bR1fh {
  position: relative;
  margin-top: 13px;
  margin-right: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.tile---bR1fh:nth-child(1),
.tile---bR1fh:nth-child(2),
.tile---bR1fh:nth-child(3),
.tile---bR1fh:nth-child(4),
.tile---bR1fh:nth-child(5) {
  margin-top: 0;
}
.tile---bR1fh a {
  text-decoration: none;
  position: relative;
}
.tile---bR1fh a:visited {
  color: #444;
}
.tile---bR1fh a:hover .imageCover---GT4be {
  display: flex;
  align-items: center;
  justify-content: center;
}
.image---Dq3Hq {
  width: 221px;
  height: 295px;
  object-fit: cover;
}
.imageCover---GT4be {
  position: absolute;
  top: 0;
  left: 0;
  width: 221px;
  height: 295px;
  display: none;
  background: rgba(0, 0, 0, 0.3);
  font-size: 17px;
  color: #ffffff;
  letter-spacing: -0.45px;
  line-height: 20px;
}
.imageCover---GT4be .visitLabel---UMw8A {
  margin-left: 5px;
}
.showDisplayText---lC4ll {
  height: 343px;
}
.showDisplayText---lC4ll:nth-child(1),
.showDisplayText---lC4ll:nth-child(2),
.showDisplayText---lC4ll:nth-child(3),
.showDisplayText---lC4ll:nth-child(4),
.showDisplayText---lC4ll:nth-child(5) {
  margin-top: -22px;
}
.displayText---lMScF {
  position: absolute;
  max-height: 50px;
  width: 221px;
  text-align: left;
  padding: 5px 1px 5px 1px;
  font-size: 12px;
  line-height: 18px;
  color: #757575;
}
@media (max-width: 1479px) {
  .tile---bR1fh {
    width: calc(1170px / 4 - 13px);
    height: calc((1170px / 4 - 13px) / 0.75);
  }
  .tile---bR1fh:nth-child(5) {
    margin-top: 13px;
  }
  .tile---bR1fh .imageWrapper---Egj0M {
    position: absolute;
  }
  .tile---bR1fh:nth-child(odd) .imageWrapper---Egj0M {
    right: 1px;
  }
  .tile---bR1fh:nth-child(even) .imageWrapper---Egj0M {
    left: 1px;
  }
  .image---Dq3Hq,
  .imageCover---GT4be {
    width: calc(1170px / 4 - 13px);
    height: calc((1170px / 4 - 13px) / 0.75);
  }
  .displayText---lMScF {
    width: calc(1170px / 4 - 13px);
    max-height: 40px;
  }
  .showDisplayText---lC4ll {
    height: calc((1170px / 4 - 13px) / 0.75 + 48px);
  }
  .showDisplayText---lC4ll:nth-child(5) {
    margin-top: 13px;
  }
  .showDisplayText---lC4ll:nth-child(1),
  .showDisplayText---lC4ll:nth-child(2),
  .showDisplayText---lC4ll:nth-child(3),
  .showDisplayText---lC4ll:nth-child(4) {
    margin-top: -12px;
  }
}
@media (max-width: 1169px) {
  .tile---bR1fh {
    width: calc(25vw - 20px);
    height: calc((25vw - 20px) / 0.75);
  }
  .tile---bR1fh:nth-child(4n + 1) {
    margin-left: 10px;
  }
  .tile---bR1fh:nth-child(5) {
    margin-top: 13px;
  }
  .tile---bR1fh .imageWrapper---Egj0M {
    position: absolute;
  }
  .tile---bR1fh:nth-child(odd) .imageWrapper---Egj0M {
    right: 1px;
  }
  .tile---bR1fh:nth-child(even) .imageWrapper---Egj0M {
    left: 1px;
  }
  .image---Dq3Hq,
  .imageCover---GT4be {
    width: calc(25vw - 20px);
    height: calc((25vw - 20px) / 0.75);
  }
  .displayText---lMScF {
    width: calc(25vw - 20px);
    max-height: 40px;
  }
  .showDisplayText---lC4ll {
    height: calc((25vw - 20px) / 0.75 + 48px);
  }
  .showDisplayText---lC4ll:nth-child(5) {
    margin-top: 13px;
  }
  .showDisplayText---lC4ll:nth-child(1),
  .showDisplayText---lC4ll:nth-child(2),
  .showDisplayText---lC4ll:nth-child(3),
  .showDisplayText---lC4ll:nth-child(4) {
    margin-top: -12px;
  }
}
@media (max-width: 911px) {
  .tile---bR1fh {
    width: calc(33vw - 20px);
    height: calc((33vw - 20px) / 0.75);
  }
  .tile---bR1fh:nth-child(4n + 1) {
    margin-left: 0px;
  }
  .tile---bR1fh:nth-child(3n + 1) {
    margin-left: 10px;
  }
  .tile---bR1fh:nth-child(5),
  .tile---bR1fh:nth-child(4) {
    margin-top: 13px;
  }
  .tile---bR1fh .imageWrapper---Egj0M {
    position: absolute;
  }
  .tile---bR1fh:nth-child(odd) .imageWrapper---Egj0M {
    right: 1px;
  }
  .tile---bR1fh:nth-child(even) .imageWrapper---Egj0M {
    left: 1px;
  }
  .image---Dq3Hq,
  .imageCover---GT4be {
    width: calc(33vw - 20px);
    height: calc((33vw - 20px) / 0.75);
  }
  .displayText---lMScF {
    width: calc(33vw - 20px);
    max-height: 40px;
  }
  .showDisplayText---lC4ll {
    height: calc((33vw - 20px) / 0.75 + 48px);
  }
  .showDisplayText---lC4ll:nth-child(5),
  .showDisplayText---lC4ll:nth-child(4) {
    margin-top: 13px;
  }
  .showDisplayText---lC4ll:nth-child(1),
  .showDisplayText---lC4ll:nth-child(2),
  .showDisplayText---lC4ll:nth-child(3) {
    margin-top: -12px;
  }
}
@media (max-width: 711px) {
  .tile---bR1fh {
    width: calc(50vw - 25px);
    height: calc((50vw - 25px) / 0.75);
  }
  .tile---bR1fh:nth-child(4n + 1),
  .tile---bR1fh:nth-child(3n + 1) {
    margin-left: 0px;
  }
  .tile---bR1fh:nth-child(2n + 1) {
    margin-left: 5px;
  }
  .tile---bR1fh:nth-child(5),
  .tile---bR1fh:nth-child(4),
  .tile---bR1fh:nth-child(3) {
    margin-top: 13px;
  }
  .tile---bR1fh .imageWrapper---Egj0M {
    position: absolute;
  }
  .tile---bR1fh:nth-child(odd) .imageWrapper---Egj0M {
    right: 1px;
  }
  .tile---bR1fh:nth-child(even) .imageWrapper---Egj0M {
    left: 1px;
  }
  .image---Dq3Hq,
  .imageCover---GT4be {
    width: calc(50vw - 25px);
    height: calc((50vw - 25px) / 0.75);
  }
  .displayText---lMScF {
    width: calc(50vw - 25px);
    max-height: 40px;
  }
  .showDisplayText---lC4ll {
    height: calc((50vw - 25px) / 0.75 + 48px);
  }
  .showDisplayText---lC4ll:nth-child(5),
  .showDisplayText---lC4ll:nth-child(4),
  .showDisplayText---lC4ll:nth-child(3) {
    margin-top: 13px;
  }
  .showDisplayText---lC4ll:nth-child(1),
  .showDisplayText---lC4ll:nth-child(2) {
    margin-top: -12px;
  }
}
@media (max-width: 511px) {
  .tile---bR1fh {
    width: calc(100vw - 25px);
    height: calc((100vw - 25px) / 0.75);
    margin-left: 5px;
  }
  .tile---bR1fh:nth-child(5),
  .tile---bR1fh:nth-child(4),
  .tile---bR1fh:nth-child(3),
  .tile---bR1fh:nth-child(2) {
    margin-top: 13px;
  }
  .tile---bR1fh .imageWrapper---Egj0M {
    position: absolute;
  }
  .tile---bR1fh:nth-child(odd) .imageWrapper---Egj0M {
    right: 1px;
  }
  .tile---bR1fh:nth-child(even) .imageWrapper---Egj0M {
    left: 1px;
  }
  .image---Dq3Hq,
  .imageCover---GT4be {
    width: calc(100vw - 25px);
    height: calc((100vw - 25px) / 0.75);
  }
  .displayText---lMScF {
    width: calc(100vw - 25px);
    max-height: 40px;
  }
  .showDisplayText---lC4ll {
    height: calc((100vw - 25px) / 0.75 + 48px);
  }
  .showDisplayText---lC4ll:nth-child(5),
  .showDisplayText---lC4ll:nth-child(4),
  .showDisplayText---lC4ll:nth-child(3),
  .showDisplayText---lC4ll:nth-child(2) {
    margin-top: 13px;
  }
  .showDisplayText---lC4ll:nth-child(1) {
    margin-top: -12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/tiktok_tile.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EASA,kBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,eAAA;AATF;AAJE;;;;;EAKE,aAAA;AAMJ;AAfA;EAoBI,qBAAA;EACA,kBAAA;AAFJ;AAII;EACE,WAAA;AAFN;AAKI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAHN;AAQA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;AANF;AASA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EAEA,aAAA;EAEA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;AATF;AAJA;EAgBI,gBAAA;AATJ;AAaA;EACE,aAAA;AAXF;AAaE;;;;;EAKE,iBAAA;AAXJ;AAeA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAbF;AAgBA;EACE;IACE,8BAAA;IACA,wCAAA;EAdF;EAgBE;IACE,gBAAA;EAdJ;EASA;IASI,kBAAA;EAfJ;EAkBE;IACE,UAAA;EAhBJ;EAmBE;IACE,SAAA;EAjBJ;EAqBA;;IAEE,8BAAA;IACA,wCAAA;EAnBF;EAsBA;IACE,8BAAA;IACA,gBAAA;EApBF;EAuBA;IACE,+CAAA;EArBF;EAuBE;IACE,gBAAA;EArBJ;EAwBE;;;;IAIE,iBAAA;EAtBJ;AACF;AA0BA;EACE;IACE,wBAAA;IACA,kCAAA;EAxBF;EAyBE;IACE,iBAAA;EAvBJ;EA0BE;IACE,gBAAA;EAxBJ;EAgBA;IAYI,kBAAA;EAzBJ;EA4BE;IACE,UAAA;EA1BJ;EA6BE;IACE,SAAA;EA3BJ;EA+BA;;IAEE,wBAAA;IACA,kCAAA;EA7BF;EAgCA;IACE,wBAAA;IACA,gBAAA;EA9BF;EAiCA;IACE,yCAAA;EA/BF;EAiCE;IACE,gBAAA;EA/BJ;EAkCE;;;;IAIE,iBAAA;EAhCJ;AACF;AAoCA;EACE;IACE,wBAAA;IACA,kCAAA;EAlCF;EAoCE;IACE,gBAAA;EAlCJ;EAoCE;IACE,iBAAA;EAlCJ;EAqCE;;IAEE,gBAAA;EAnCJ;EAsBA;IAiBI,kBAAA;EApCJ;EAuCE;IACE,UAAA;EArCJ;EAwCE;IACE,SAAA;EAtCJ;EA0CA;;IAEE,wBAAA;IACA,kCAAA;EAxCF;EA2CA;IACE,wBAAA;IACA,gBAAA;EAzCF;EA4CA;IACE,yCAAA;EA1CF;EA4CE;;IAEE,gBAAA;EA1CJ;EA6CE;;;IAGE,iBAAA;EA3CJ;AACF;AA+CA;EACE;IACE,wBAAA;IACA,kCAAA;EA7CF;EA+CE;;IAEE,gBAAA;EA7CJ;EAgDE;IACE,gBAAA;EA9CJ;EAiDE;;;IAGE,gBAAA;EA/CJ;EA+BA;IAoBI,kBAAA;EAhDJ;EAmDE;IACE,UAAA;EAjDJ;EAoDE;IACE,SAAA;EAlDJ;EAsDA;;IAEE,wBAAA;IACA,kCAAA;EApDF;EAuDA;IACE,wBAAA;IACA,gBAAA;EArDF;EAwDA;IACE,yCAAA;EAtDF;EAwDE;;;IAGE,gBAAA;EAtDJ;EAyDE;;IAEE,iBAAA;EAvDJ;AACF;AA2DA;EACE;IACE,yBAAA;IACA,mCAAA;IACA,gBAAA;EAzDF;EA2DE;;;;IAIE,gBAAA;EAzDJ;EAgDA;IAaI,kBAAA;EA1DJ;EA6DE;IACE,UAAA;EA3DJ;EA8DE;IACE,SAAA;EA5DJ;EAgEA;;IAEE,yBAAA;IACA,mCAAA;EA9DF;EAiEA;IACE,yBAAA;IACA,gBAAA;EA/DF;EAkEA;IACE,0CAAA;EAhEF;EAkEE;;;;IAIE,gBAAA;EAhEJ;EAmEE;IACE,iBAAA;EAjEJ;AACF","sourcesContent":[".tile {\n  position: relative;\n  margin-top: 13px;\n\n  &:nth-child(1),\n  &:nth-child(2),\n  &:nth-child(3),\n  &:nth-child(4),\n  &:nth-child(5) {\n    margin-top: 0;\n  }\n  margin-right: 13px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  cursor: pointer;\n\n  a {\n    text-decoration: none;\n    position: relative;\n\n    &:visited {\n      color: #444;\n    }\n\n    &:hover .imageCover {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n}\n\n.image {\n  width: 221px;\n  height: 295px;\n  object-fit: cover;\n}\n\n.imageCover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 221px;\n  height: 295px;\n\n  display: none;\n\n  background: rgba(0, 0, 0, 0.3);\n  font-size: 17px;\n  color: #ffffff;\n  letter-spacing: -0.45px;\n  line-height: 20px;\n\n  .visitLabel {\n    margin-left: 5px;\n  }\n}\n\n.showDisplayText {\n  height: 343px;\n\n  &:nth-child(1),\n  &:nth-child(2),\n  &:nth-child(3),\n  &:nth-child(4),\n  &:nth-child(5) {\n    margin-top: -22px;\n  }\n}\n\n.displayText {\n  position: absolute;\n  max-height: 50px;\n  width: 221px;\n  text-align: left;\n  padding: 5px 1px 5px 1px;\n  font-size: 12px;\n  line-height: 18px;\n  color: #757575;\n}\n\n@media (max-width: 1479px) {\n  .tile {\n    width: calc(1170px / 4 - 13px);\n    height: calc((1170px / 4 - 13px) / 0.75);\n\n    &:nth-child(5) {\n      margin-top: 13px;\n    }\n\n    .imageWrapper {\n      position: absolute;\n    }\n\n    &:nth-child(odd) .imageWrapper {\n      right: 1px;\n    }\n\n    &:nth-child(even) .imageWrapper {\n      left: 1px;\n    }\n  }\n\n  .image,\n  .imageCover {\n    width: calc(1170px / 4 - 13px);\n    height: calc((1170px / 4 - 13px) / 0.75);\n  }\n\n  .displayText {\n    width: calc(1170px / 4 - 13px);\n    max-height: 40px;\n  }\n\n  .showDisplayText {\n    height: calc((1170px / 4 - 13px) / 0.75 + 48px);\n\n    &:nth-child(5) {\n      margin-top: 13px;\n    }\n\n    &:nth-child(1),\n    &:nth-child(2),\n    &:nth-child(3),\n    &:nth-child(4) {\n      margin-top: -12px;\n    }\n  }\n}\n\n@media (max-width: 1169px) {\n  .tile {\n    width: calc(25vw - 20px);\n    height: calc((25vw - 20px) / 0.75);\n    &:nth-child(4n + 1) {\n      margin-left: 10px;\n    }\n\n    &:nth-child(5) {\n      margin-top: 13px;\n    }\n\n    .imageWrapper {\n      position: absolute;\n    }\n\n    &:nth-child(odd) .imageWrapper {\n      right: 1px;\n    }\n\n    &:nth-child(even) .imageWrapper {\n      left: 1px;\n    }\n  }\n\n  .image,\n  .imageCover {\n    width: calc(25vw - 20px);\n    height: calc((25vw - 20px) / 0.75);\n  }\n\n  .displayText {\n    width: calc(25vw - 20px);\n    max-height: 40px;\n  }\n\n  .showDisplayText {\n    height: calc((25vw - 20px) / 0.75 + 48px);\n\n    &:nth-child(5) {\n      margin-top: 13px;\n    }\n\n    &:nth-child(1),\n    &:nth-child(2),\n    &:nth-child(3),\n    &:nth-child(4) {\n      margin-top: -12px;\n    }\n  }\n}\n\n@media (max-width: 911px) {\n  .tile {\n    width: calc(33vw - 20px);\n    height: calc((33vw - 20px) / 0.75);\n\n    &:nth-child(4n + 1) {\n      margin-left: 0px;\n    }\n    &:nth-child(3n + 1) {\n      margin-left: 10px;\n    }\n\n    &:nth-child(5),\n    &:nth-child(4) {\n      margin-top: 13px;\n    }\n\n    .imageWrapper {\n      position: absolute;\n    }\n\n    &:nth-child(odd) .imageWrapper {\n      right: 1px;\n    }\n\n    &:nth-child(even) .imageWrapper {\n      left: 1px;\n    }\n  }\n\n  .image,\n  .imageCover {\n    width: calc(33vw - 20px);\n    height: calc((33vw - 20px) / 0.75);\n  }\n\n  .displayText {\n    width: calc(33vw - 20px);\n    max-height: 40px;\n  }\n\n  .showDisplayText {\n    height: calc((33vw - 20px) / 0.75 + 48px);\n\n    &:nth-child(5),\n    &:nth-child(4) {\n      margin-top: 13px;\n    }\n\n    &:nth-child(1),\n    &:nth-child(2),\n    &:nth-child(3) {\n      margin-top: -12px;\n    }\n  }\n}\n\n@media (max-width: 711px) {\n  .tile {\n    width: calc(50vw - 25px);\n    height: calc((50vw - 25px) / 0.75);\n\n    &:nth-child(4n + 1),\n    &:nth-child(3n + 1) {\n      margin-left: 0px;\n    }\n\n    &:nth-child(2n + 1) {\n      margin-left: 5px;\n    }\n\n    &:nth-child(5),\n    &:nth-child(4),\n    &:nth-child(3) {\n      margin-top: 13px;\n    }\n\n    .imageWrapper {\n      position: absolute;\n    }\n\n    &:nth-child(odd) .imageWrapper {\n      right: 1px;\n    }\n\n    &:nth-child(even) .imageWrapper {\n      left: 1px;\n    }\n  }\n\n  .image,\n  .imageCover {\n    width: calc(50vw - 25px);\n    height: calc((50vw - 25px) / 0.75);\n  }\n\n  .displayText {\n    width: calc(50vw - 25px);\n    max-height: 40px;\n  }\n\n  .showDisplayText {\n    height: calc((50vw - 25px) / 0.75 + 48px);\n\n    &:nth-child(5),\n    &:nth-child(4),\n    &:nth-child(3) {\n      margin-top: 13px;\n    }\n\n    &:nth-child(1),\n    &:nth-child(2) {\n      margin-top: -12px;\n    }\n  }\n}\n\n@media (max-width: 511px) {\n  .tile {\n    width: calc(100vw - 25px);\n    height: calc((100vw - 25px) / 0.75);\n    margin-left: 5px;\n\n    &:nth-child(5),\n    &:nth-child(4),\n    &:nth-child(3),\n    &:nth-child(2) {\n      margin-top: 13px;\n    }\n\n    .imageWrapper {\n      position: absolute;\n    }\n\n    &:nth-child(odd) .imageWrapper {\n      right: 1px;\n    }\n\n    &:nth-child(even) .imageWrapper {\n      left: 1px;\n    }\n  }\n\n  .image,\n  .imageCover {\n    width: calc(100vw - 25px);\n    height: calc((100vw - 25px) / 0.75);\n  }\n\n  .displayText {\n    width: calc(100vw - 25px);\n    max-height: 40px;\n  }\n\n  .showDisplayText {\n    height: calc((100vw - 25px) / 0.75 + 48px);\n\n    &:nth-child(5),\n    &:nth-child(4),\n    &:nth-child(3),\n    &:nth-child(2) {\n      margin-top: 13px;\n    }\n\n    &:nth-child(1) {\n      margin-top: -12px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tile": `tile---bR1fh`,
	"imageCover": `imageCover---GT4be`,
	"image": `image---Dq3Hq`,
	"visitLabel": `visitLabel---UMw8A`,
	"showDisplayText": `showDisplayText---lC4ll`,
	"displayText": `displayText---lMScF`,
	"imageWrapper": `imageWrapper---Egj0M`
};
export default ___CSS_LOADER_EXPORT___;
